export const isDonwloadableFile = (
	url: string,
	exclude: Array<string> = ['htm', 'html', 'php', 'asp', 'aspx']
): boolean => {
	const urlWithoutTrailingSlash = url.replace(/\/$/, '')
	const slashParts = urlWithoutTrailingSlash.split('/')

	if (url.substring(0, 1) === '/') {
		if (slashParts.length <= 1) return false
	} else if (slashParts.length <= 3) return false

	const lastSlashPart = slashParts[slashParts.length - 1]
	const dotParts = lastSlashPart.split('.')

	if (dotParts.length <= 1) return false

	const extension = dotParts[dotParts.length - 1].toLowerCase().split('?')[0]
	for (const i in exclude) {
		if (exclude[i].toLowerCase() === extension) return false
	}

	return true
}
